import { atom, getDefaultStore, useAtomValue } from 'jotai'

type ConnectionState = 'connecting' | 'connected' | 'closed'

const store = getDefaultStore()
export const wsConnectionStatusAtom = atom<ConnectionState>('closed')
export const setWsConnectionStatus = (value: ConnectionState) =>
  store.set(wsConnectionStatusAtom, value)
export const getWsConnectionStatus = () => store.get(wsConnectionStatusAtom)

// Keeping previous export name
export const isWebsocketConnected = () => {
  return getWsConnectionStatus() === 'connected'
}

/**
 * Overloaded function to provide more detailed status if needed
 * @param args
 */
export function useWsConnectionStatus(args: { detailed: true }): ConnectionState
export function useWsConnectionStatus(args?: { detailed?: false }): boolean
export function useWsConnectionStatus(args?: { detailed?: boolean }) {
  const rawValue = useAtomValue(wsConnectionStatusAtom, { store })
  if (args?.detailed) return rawValue
  return rawValue === 'connected'
}
